export default __webpack_public_path__ + "static/media/tekken-7.e93a8290.png";